export class NumberUtils {
  
  public static DEFAULT_DECIMAL_DIGITS: number = 2;
  public static DECIMAL_POINT = ".";

  public static formatNumberIfNecessary(value, locale: string, decimalDigits: number) {
    let decimal = (decimalDigits) ? decimalDigits : this.DEFAULT_DECIMAL_DIGITS;
    if (value === "???" || value === undefined) {
      return "???";
    }

    if (value !== null && value !== "" && !isNaN(value)) {
      return Number(value).toLocaleString(locale, { minimumFractionDigits: decimal, maximumFractionDigits: decimal, useGrouping:true });
    }
    return value;
  }

  public static isIntegerNumber(value: string) {
    const regExpInteger = /^\d+$/;
    return (String(value).trim() !== "" && regExpInteger.test(value));
  }

  public static isNegativeNumber(value) {
    return !Object.is(Math.abs(value), +value);
  }

  public static decimalToTime(val: any): string {
    if (typeof val !== 'string') val = val != null ? String(val) : '';
    const num = parseFloat(val.replace(',', '.'));
    if (isNaN(num)) return '';
    const hours = Math.floor(num);
    const minutes = Math.round((num - hours) * 60);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  public static timeToDecimal(val: any): string {
    if (typeof val !== 'string') val = val != null ? String(val) : '';
    const [h, m] = val.split(":").map(Number);
    if (isNaN(h) || isNaN(m)) return '';
    return (h + m / 60).toFixed(2);
  }

  public static decimalOrTimeToTime(val: any): string {
    if (typeof val !== 'string') val = val?.toString() ?? '';
    // Accepts hh:mm or h:mm or h...h:mm (any number of digits for hours)
    if (this.isTimeFormat(val)) {
      return val;
    }
    // Accepts decimal numbers
    return this.decimalToTime(val);
  }
  static isTimeFormat(value: any): boolean {
    return /^\d+:\d{2}$/.test(value);
  }
}
